import { render, staticRenderFns } from "./OnsiteTodayTable.vue?vue&type=template&id=5a70dd70&scoped=true&"
import script from "./OnsiteTodayTable.vue?vue&type=script&lang=js&"
export * from "./OnsiteTodayTable.vue?vue&type=script&lang=js&"
import style0 from "./OnsiteTodayTable.vue?vue&type=style&index=0&id=5a70dd70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a70dd70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VContainer,VSimpleTable})
